<template>
  <v-app-bar
    app
    color="white"
    :elevation="scrolled ? 2 : 0"
    height="68"
    style="border-bottom: 1px solid #f0f0f0"
  >
    <v-container class="d-flex align-center pa-0" style="max-width: 1200px">
      <!-- Logo -->
      <router-link
        to="/"
        class="logo d-flex align-center mr-10"
        style="text-decoration: none"
      >
        <v-icon color="primary" size="26" class="mr-2"
          >mdi-lightning-bolt</v-icon
        >
        <span class="logo-text">Daalgavar.MN</span>
      </router-link>

      <!-- Nav Links (desktop) -->
      <!-- <div class="d-none d-md-flex align-center">
        <a class="nav-link mx-4" href="#">{{ $t('nav.features') }}</a>
        <router-link class="nav-link mx-4" to="/students">{{ $t('nav.forStudents') }}</router-link>
        <a class="nav-link mx-4" href="#">{{ $t('nav.pricing') }}</a>
      </div> -->

      <v-spacer />

      <!-- CTA Buttons -->
      <div class="d-flex align-center" style="gap: 8px">
        <v-btn
          color="#F77317"
          dark
          depressed
          rounded
          class="px-5 font-weight-semibold"
          style="letter-spacing: 0; text-transform: none; font-size: 0.9rem"
          @click="dialog = true"
        >
          {{ $t("nav.login") }}
        </v-btn>
      </div>
    </v-container>

    <!-- Registration Dialog -->
    <v-dialog v-model="dialog" max-width="480" persistent>
      <v-card style="border-radius: 20px; padding: 8px">
        <v-card-title class="dialog-title pt-6 px-6 mb-4"
          >Сургуулиа бүртгүүлэх</v-card-title
        >
        <v-card-subtitle class="dialog-sub px-6 pb-4"
          >Мэдээллийг бөглөж бидэнтэй холбогдоорой.</v-card-subtitle
        >
        <v-card-text class="px-6">
          <v-text-field
            v-model="form.school"
            label="Сургуулийн нэр"
            outlined
            dense
            rounded
            class="mb-2"
            prepend-inner-icon="mdi-school-outline"
          />
          <v-text-field
            v-model="form.phone"
            label="Утасны дугаар"
            outlined
            dense
            rounded
            class="mb-2"
            prepend-inner-icon="mdi-phone-outline"
            type="tel"
          />
          <v-text-field
            v-model="form.email"
            label="И-мэйл хаяг"
            outlined
            dense
            rounded
            prepend-inner-icon="mdi-email-outline"
            type="email"
          />
        </v-card-text>
        <v-card-actions class="px-6 pb-6" style="gap: 10px">
          <v-btn
            text
            rounded
            class="flex-grow-1"
            @click="dialog = false"
            style="text-transform: none; color: #888"
            >Цуцлах</v-btn
          >
          <v-btn
            color="primary"
            depressed
            rounded
            class="flex-grow-1"
            @click="_saveToFirebase()"
            style="text-transform: none; font-weight: 700"
            >Илгээх</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
const fb = require("@/firebaseConfig.js");
export default {
  name: "NavBar",
  data() {
    return {
      scrolled: false,
      dialog: false,
      form: { school: "", phone: "", email: "" },
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    async _saveToFirebase() {
      if (
        this.form.school.trim() === "" ||
        this.form.phone.trim() === "" ||
        this.form.email.trim() === ""
      ) {
        this.$swal.fire({
          icon: "error",
          title: "Мэдээлэл дутуу байна!",
          text: "Бүх талбарыг бөглөнө үү.",
          confirmButtonText: "OK",
        });
        return;
      }

      await fb.db
        .collection("_schoolRequests")
        .doc(String(this.form.phone))
        .set({
          form: this.form,
          createdAt: fb.firestore.FieldValue.serverTimestamp(),
        });
      this.dialog = false;
      this.$swal.fire({
        icon: "success",
        title: "Амжилттай илгээгдлээ!",
        text: "Бид тантай холбогдох болно.",
        confirmButtonText: "OK",
      });
    },
    onScroll() {
      this.scrolled = window.scrollY > 10;
    },
    setLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
    },
  },
};
</script>

<style scoped>
.logo-text {
  font-size: 1.25rem;
  font-weight: 800;
  color: #1b1c2e;
  letter-spacing: -0.5px;
}

.nav-link {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  text-decoration: none;
  transition: color 0.2s;
  letter-spacing: 0.01em;
  text-transform: none;
}

.nav-link:hover {
  color: #4257b2;
}

.lang-toggle {
  display: flex;
  align-items: center;
  background: #f3f4f6;
  border-radius: 100px;
  padding: 4px;
  gap: 2px;
}

.lang-btn {
  padding: 5px 13px;
  font-size: 0.72rem;
  font-weight: 700;
  color: #9ca3af;
  border: none;
  background: transparent;
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.2s ease;
  letter-spacing: 0.6px;
  font-family: inherit;
}

.lang-btn.active {
  background: #f8a228;
  color: #fff;
  box-shadow: 0 2px 8px rgba(248, 162, 40, 0.35);
}

.lang-btn:hover:not(.active) {
  color: #374151;
  background: #e5e7eb;
}
</style>
